import React from 'react';
function Italic({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M17 6H11" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 18H7" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 6L10 18" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default Italic;
